function NewQuery(searchTerm, currentPage, labelsPerPage) {
  return {
    "query": {
      "function_score": {
        "query": {
          "bool": {
            "should": [
              {
                "match": {
                  "label.ngram": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "ngram search * score_multiply_10"
                  }
                }
              },
              {
                "multi_match": {
                  "query": searchTerm,
                  "fields": [
                    "label.ngram_transform1",
                    "label.ngram_transform2"
                  ],
                  "boost": 10,
                  "_name": "transform ngram search * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "match": {
                        "label.first_3_chars_drop_first_keep_rest": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 8,
                  "_name": "M and ATT and HEW * score_multiply_8"
                }
              },        
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.fourth_char_transform1",
                          "label.fourth_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 15,
                  "_name": "M and transform(A) and transform(T) and transform(T) and HEW * score_multiply_15"
                }
              },        
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 10,
                  "_name": "M and transform(A) and transform(T) and HEW * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1_search_third_char",
                          "label.second_char_transform2_search_third_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1_search_fourth_char",
                          "label.third_char_transform2_search_fourth_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 10,
                  "_name": "M and *transform(A) and transform(T) and HEW * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.fourth_char_transform1",
                          "label.fourth_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 6,
                  "_name": "M and transform(T) and transform(T) and HEW * score_multiply_6"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "match": {
                        "label.last_3_chars": searchTerm
                      }
                    }
                  ],
                  "boost": 5,
                  "_name": "M and HEW * score_multiply_5"
                }
              },        
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.fourth_char_transform1",
                          "label.fourth_char_transform2"
                        ]
                      }
                    }
                  ],
                  "boost": 4,
                  "_name": "M and transform(A) and transform(T) and transform(T) * score_multiply_4"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    }
                  ],
                  "boost": 3,
                  "_name": "M and transform(A) and transform(T) * score_multiply_3"
                }
              },     
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.fourth_char"
                        ]
                      }
                    }
                  ],
                  "boost": 4,
                  "_name": "M and transform(A) and T and T * score_multiply_4"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_3_chars_ngram": searchTerm
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "MAT * score_multiply_2"
                }
              }
            ],
            "filter": [
              {
                "term": {
                  "available": "true"
                }
              }
            ],
            "minimum_should_match": 1
          }
        },
        "functions": [
          {
            "filter": {
              "term": {
                "supplier_id": "19"
              }
            },
            "weight": 2
          }
        ],
        "score_mode": "multiply",
        "boost_mode": "multiply"
      }
    },
    "size": labelsPerPage,
    "from": (currentPage - 1) * labelsPerPage,
    "track_total_hits": true
  };
}
export default NewQuery;
